import { Target, Eye } from "lucide-react";

export const AboutMissionVision = () => {
  return (
    <section data-testid="about-mission-vision" className="bg-[#F2F9F5] border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 grid grid-cols-1 sm:grid-cols-2 gap-10">
        <div data-testid="about-mission" className="space-y-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#0B4F37]/10 text-[#0B4F37]">
            <Target className="h-5 w-5" strokeWidth={1.8} />
          </span>
          <h2 className="font-heading text-xl sm:text-2xl font-bold text-[#042D1F]">Mission</h2>
          <p className="text-base text-slate-600 leading-relaxed">
            To deliver quality agricultural and natural products with consistency, transparency and reliability
            while building long-term relationships with customers and trusted sourcing partners.
          </p>
        </div>
        <div data-testid="about-vision" className="space-y-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#0B4F37]/10 text-[#0B4F37]">
            <Eye className="h-5 w-5" strokeWidth={1.8} />
          </span>
          <h2 className="font-heading text-xl sm:text-2xl font-bold text-[#042D1F]">Vision</h2>
          <p className="text-base text-slate-600 leading-relaxed">
            To become a trusted global name in agricultural and natural product trade by connecting quality Indian
            products with markets across the world.
          </p>
        </div>
      </div>
    </section>
  );
};
